import { useState } from "react";
import { ArrowRight, CheckCircle } from "lucide-react";
import { CORE_SOLUTIONS } from "../data/brochure";

const SolutionPanel = ({ solution, onEnquire }) => (
  <div className="solution-panel" key={solution.value} data-testid={`solution-panel-${solution.value}`}>
    <div className="solution-media">
      <img src={solution.image} alt={solution.title} loading="lazy" />
      <span className="solution-slogan">{solution.slogan}</span>
    </div>
    <div className="solution-body">
      <span className="solution-number">{solution.number}</span>
      <h3 className="solution-title" data-testid="solution-title">{solution.title}</h3>
      <p className="solution-tagline">{solution.tagline}</p>
      <p className="solution-desc">{solution.desc}</p>
      <ul className="solution-outcomes">
        {solution.outcomes.map(([title, desc]) => (
          <li key={title}>
            <CheckCircle className="solution-outcome-icon" />
            <div><strong>{title}</strong><span>{desc}</span></div>
          </li>
        ))}
      </ul>
      <button className="btn-primary solution-cta" onClick={() => onEnquire(solution.value)} data-testid={`solution-enquire-${solution.value}`}>
        Enquire About This Programme <ArrowRight className="btn-icon" />
      </button>
    </div>
  </div>
);

export const CoreSolutions = ({ innerRef, onEnquire }) => {
  const [active, setActive] = useState(0);
  return (
    <section id="programs" className="solutions-section section-animate" ref={innerRef} data-testid="programs-section">
      <div className="section-header">
        <span className="solutions-eyebrow">People &nbsp;|&nbsp; Teams &nbsp;|&nbsp; Leaders &nbsp;|&nbsp; Business Impact</span>
        <h2 className="section-title" data-testid="programs-title">Our Core Training Solutions</h2>
        <div className="section-divider"></div>
        <p className="section-subtitle">HRD Corp claimable programmes. Learn. Experience. Grow. Together.</p>
      </div>
      <div className="solutions-layout">
        <div className="solutions-tabs" role="tablist" data-testid="solutions-tabs">
          {CORE_SOLUTIONS.map((s, i) => (
            <button key={s.value} role="tab" aria-selected={active === i} className={`solution-tab ${active === i ? "active" : ""}`}
              onClick={() => setActive(i)} data-testid={`solution-tab-${s.value}`}>
              <span className="solution-tab-number">{s.number}</span>
              <span className="solution-tab-title">{s.title}</span>
            </button>
          ))}
        </div>
        <SolutionPanel solution={CORE_SOLUTIONS[active]} onEnquire={onEnquire} />
      </div>
    </section>
  );
};
